import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Stepper/sgds-step";
import { register } from "../../utils/ce-registry";

register("sgds-step", Component);

export default createComponent({
  react: React,
  tagName: "sgds-step",
  elementClass: Component,
  events: {}
});
